/**
 * Strategy Routes Constants
 * Strategy Studio App
 */

export const STRATEGY_ROUTES = {
  HOME: '/strategy',
  PLANNING: '/strategy/planning',
  EXECUTION: '/strategy/execution',
} as const;
